import { TaskState } from '@Common/types/bo/tasks';

export const taskStateTranslations: Record<TaskState, string> = {
  PENDING: 'Pending',
  AWAITING_CUSTOMER: 'Awaiting Customer',
  RESOLVED: 'Resolved',
  REJECTED: 'Rejected',
};
